import { render, staticRenderFns } from "./DecidedMasters.vue?vue&type=template&id=664c2ee7&scoped=true&"
import script from "./DecidedMasters.vue?vue&type=script&lang=js&"
export * from "./DecidedMasters.vue?vue&type=script&lang=js&"
import style0 from "./DecidedMasters.vue?vue&type=style&index=0&id=664c2ee7&prod&lang=css&"
import style1 from "./DecidedMasters.vue?vue&type=style&index=1&id=664c2ee7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c2ee7",
  null
  
)

export default component.exports